import { useState } from "react";
import { useNavigate } from "react-router-dom";

const contracts = [
  {
    id: "CT20250413003",
    title: "三亚5日亲子深度游",
    type: "线路",
    typeColor: "#065F46",
    typeBg: "#ECFDF8",
    date: "2025-04-13",
    startDate: "2025-05-20",
    endDate: "2025-05-25",
    travelers: "6人（2大4小）",
    amount: "¥4,800",
    status: "已签署",
    statusColor: "#10B981",
    statusBg: "#F0FDF4",
    party: "美伊国际旅行社有限公司",
    signDate: "2025-04-13 16:45",
    contractItems: [
      { label: "5天4晚标准住宿（双人间×2）", included: true },
      { label: "每日导游服务（8小时/天）", included: true },
      { label: "蜈支洲岛门票", included: true },
      { label: "天涯海角·槟榔谷门票", included: true },
      { label: "机场接送服务", included: true },
      { label: "旅游意外保险", included: true },
    ],
    cancelPolicy: "出发前7天（含）：免费取消，全额退款；出发前3~7天：退款70%；出发前3天内：不予退款",
    partyA: { name: "林晓雨", idCard: "310***1234", phone: "138****8888" },
  },
  {
    id: "CT20250410001",
    title: "三亚5天4晚度假套餐",
    type: "组合",
    typeColor: "#3B5BDB",
    typeBg: "#F0F4FF",
    date: "2025-04-10",
    startDate: "2025-05-01",
    endDate: "2025-05-05",
    travelers: "4人",
    amount: "¥8,000",
    status: "已签署",
    statusColor: "#10B981",
    statusBg: "#F0FDF4",
    party: "美伊国际旅行社有限公司",
    signDate: "2025-04-10 14:30",
    contractItems: [
      { label: "4晚五星级酒店（大床房×2间）", included: true },
      { label: "商务租车（别克GL8·含司机）", included: true },
      { label: "5日经典景区线路", included: true },
      { label: "专业导游（3天）", included: true },
    ],
    cancelPolicy: "入住前3天免费取消；入住前1-3天收取首晚房费；入住前1天内不可取消",
    partyA: { name: "林晓雨", idCard: "310***1234", phone: "138****8888" },
  },
  {
    id: "CT20250312002",
    title: "大理古城3日游",
    type: "线路",
    typeColor: "#065F46",
    typeBg: "#ECFDF8",
    date: "2025-03-12",
    startDate: "2025-03-15",
    endDate: "2025-03-18",
    travelers: "2人",
    amount: "¥2,380",
    status: "已完成",
    statusColor: "#6B7280",
    statusBg: "#F3F4F6",
    party: "美伊国际旅行社有限公司",
    signDate: "2025-03-12 10:20",
    contractItems: [
      { label: "3天2晚民宿住宿", included: true },
      { label: "全程导游服务", included: true },
      { label: "苍山洱海门票", included: true },
    ],
    cancelPolicy: "出发前5天免费取消；出发前2-5天收取20%手续费；出发前2天内不可退款",
    partyA: { name: "林晓雨", idCard: "310***1234", phone: "138****8888" },
  },
];

function ContractDetailModal({ contract, onClose }: { contract: typeof contracts[0]; onClose: () => void }) {
  const [activeTab, setActiveTab] = useState<"content" | "info">("content");

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC',sans-serif" }}>
      {/* Header */}
      <div
        className="relative overflow-hidden flex-shrink-0"
        style={{ background: "linear-gradient(145deg,#1A1A2E 0%,#16213E 60%,#0F3460 100%)" }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute rounded-full" style={{ width: 180, height: 180, top: -40, right: -20, background: "rgba(255,107,53,0.1)", filter: "blur(35px)" }} />
        </div>
        <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={onClose}
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
            </button>
            <div className="flex items-center gap-2 flex-1">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}>
                <i className="ri-file-paper-2-line text-white" style={{ fontSize: 13 }} />
              </div>
              <div>
                <div className="text-sm font-bold text-white leading-tight">电子合同</div>
                <div className="text-xs leading-tight" style={{ color: "rgba(255,255,255,0.45)" }}>美伊旅行 · {contract.id}</div>
              </div>
            </div>
            <span className="text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap"
              style={{ background: contract.status === "已签署" ? "rgba(16,185,129,0.2)" : "rgba(255,255,255,0.12)", color: "#fff", border: `1px solid ${contract.status === "已签署" ? "rgba(16,185,129,0.4)" : "rgba(255,255,255,0.18)"}` }}>
              {contract.status}
            </span>
          </div>
          {/* Contract title */}
          <div className="text-lg font-bold text-white mb-1">{contract.title}</div>
          <div className="flex items-center gap-3 text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>
            <span><i className="ri-calendar-line mr-1" style={{ fontSize: 11 }} />{contract.startDate} ~ {contract.endDate}</span>
            <span><i className="ri-user-line mr-1" style={{ fontSize: 11 }} />{contract.travelers}</span>
          </div>
        </div>
        {/* Tabs */}
        <div className="flex px-5 gap-5" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          {(["content", "info"] as const).map((t) => (
            <button
              key={t}
              onClick={() => setActiveTab(t)}
              className="py-3 text-sm cursor-pointer relative whitespace-nowrap flex-shrink-0 transition-colors"
              style={{ color: activeTab === t ? "#FF6B35" : "rgba(255,255,255,0.45)", fontWeight: activeTab === t ? 700 : 400 }}
            >
              {t === "content" ? "合同内容" : "签约信息"}
              {activeTab === t && <div className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full" style={{ height: 2.5, width: 20, background: "#FF6B35" }} />}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {activeTab === "content" && (
          <div className="px-4 py-4 space-y-3">
            {/* Amount highlight */}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-xs text-gray-400 mb-0.5">合同金额</div>
                  <div className="text-2xl font-bold" style={{ color: "#EF4444" }}>{contract.amount}</div>
                </div>
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-2xl"
                  style={{ background: "linear-gradient(135deg,#F0FDF4,#DCFCE7)" }}
                >
                  <i className="ri-checkbox-circle-fill" style={{ color: "#10B981", fontSize: 28 }} />
                </div>
              </div>
              <div className="mt-3 flex items-center gap-2 px-3 py-2 rounded-xl" style={{ background: "#F0FDF4" }}>
                <i className="ri-time-line flex-shrink-0" style={{ color: "#10B981", fontSize: 13 }} />
                <span className="text-xs text-green-700">签署时间：{contract.signDate}</span>
              </div>
            </div>

            {/* Service items */}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">服务内容</div>
              <div className="space-y-2">
                {contract.contractItems.map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "#ECFDF5" }}>
                      <i className="ri-check-line" style={{ color: "#10B981", fontSize: 11 }} />
                    </div>
                    <span className="text-sm text-gray-700">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Cancel policy */}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-2">退改政策</div>
              <div className="px-3 py-3 rounded-xl text-xs text-gray-600 leading-relaxed" style={{ background: "#FFF7ED" }}>
                <i className="ri-information-line mr-1.5" style={{ color: "#F59E0B" }} />
                {contract.cancelPolicy}
              </div>
            </div>

            {/* Legal note */}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-2">免责声明</div>
              <p className="text-xs text-gray-400 leading-relaxed">
                旅游者在旅游活动中应遵守行程安排，旅行社对旅游者个人行为造成的意外不承担责任。如遇不可抗力因素（台风、疫情等），双方应协商解决。本合同自双方签署后即时生效，具有法律约束力。
              </p>
            </div>
          </div>
        )}

        {activeTab === "info" && (
          <div className="px-4 py-4 space-y-3">
            {/* Parties */}
            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">甲方（旅游者）</div>
              <div className="space-y-2">
                {[
                  { label: "姓名", value: contract.partyA.name },
                  { label: "证件号", value: contract.partyA.idCard },
                  { label: "联系电话", value: contract.partyA.phone },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between items-center py-2" style={{ borderBottom: "1px solid #F8F8F8" }}>
                    <span className="text-xs text-gray-400">{label}</span>
                    <span className="text-sm font-medium text-gray-700">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">乙方（旅行社）</div>
              <div className="space-y-2">
                {[
                  { label: "公司名称", value: contract.party },
                  { label: "许可证号", value: "L-SC00123" },
                  { label: "联系电话", value: "400-888-8888" },
                  { label: "地址", value: "三亚市海棠区旅游路88号" },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between items-center py-2" style={{ borderBottom: "1px solid #F8F8F8" }}>
                    <span className="text-xs text-gray-400">{label}</span>
                    <span className="text-sm font-medium text-gray-700 text-right max-w-[60%]">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
              <div className="text-sm font-bold text-gray-900 mb-3">合同信息</div>
              <div className="space-y-2">
                {[
                  { label: "合同编号", value: contract.id },
                  { label: "签订日期", value: contract.signDate },
                  { label: "产品类型", value: contract.type },
                  { label: "出行日期", value: `${contract.startDate} ~ ${contract.endDate}` },
                  { label: "出行人数", value: contract.travelers },
                  { label: "合同金额", value: contract.amount, highlight: true },
                ].map(({ label, value, highlight }) => (
                  <div key={label} className="flex justify-between items-center py-2" style={{ borderBottom: "1px solid #F8F8F8" }}>
                    <span className="text-xs text-gray-400">{label}</span>
                    <span className={`text-sm font-medium ${highlight ? "text-red-500" : "text-gray-700"}`}>{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Bottom action bar */}
      <div className="flex-shrink-0 bg-white px-5 py-4 flex gap-3" style={{ borderTop: "1px solid #F5F5F5" }}>
        <button
          className="flex-1 py-3 rounded-2xl text-sm font-semibold cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          style={{ background: "#F5F5F5", color: "#6B7280" }}
        >
          <i className="ri-share-forward-line" style={{ fontSize: 15 }} />分享
        </button>
        <button
          className="flex-1 py-3 rounded-2xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 active:scale-[0.98] transition-all"
          style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}
        >
          <i className="ri-download-2-line" style={{ fontSize: 15 }} />下载合同
        </button>
      </div>
    </div>
  );
}

export default function ContractsPage() {
  const navigate = useNavigate();
  const [selectedContract, setSelectedContract] = useState<typeof contracts[0] | null>(null);

  if (selectedContract) {
    return <ContractDetailModal contract={selectedContract} onClose={() => setSelectedContract(null)} />;
  }

  return (
    <div
      className="min-h-screen pb-10"
      style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}
    >
      {/* Header */}
      <div
        className="relative overflow-hidden"
        style={{ background: "linear-gradient(145deg,#1A1A2E 0%,#16213E 60%,#0F3460 100%)" }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute rounded-full" style={{ width: 160, height: 160, top: -30, right: -10, background: "rgba(255,107,53,0.1)", filter: "blur(30px)" }} />
        </div>
        <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
          <div className="flex items-center gap-3 mb-4">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
            </button>
            <div className="flex items-center gap-2 flex-1">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}>
                <i className="ri-file-paper-2-line text-white" style={{ fontSize: 13 }} />
              </div>
              <div>
                <div className="text-base font-bold text-white leading-tight">电子合同</div>
                <div className="text-xs leading-tight" style={{ color: "rgba(255,255,255,0.45)" }}>美伊旅行</div>
              </div>
            </div>
          </div>
          <div className="text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>共 {contracts.length} 份合同</div>
        </div>
      </div>

      {/* Contract list */}
      <div className="px-4 py-4 space-y-3">
        {contracts.map((c) => (
          <div
            key={c.id}
            onClick={() => setSelectedContract(c)}
            className="rounded-2xl overflow-hidden cursor-pointer active:scale-[0.99] transition-all"
            style={{ background: "#fff" }}
          >
            {/* Top strip */}
            <div className="px-4 pt-4 pb-3" style={{ borderBottom: "1px solid #F5F5F7" }}>
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: c.typeBg, color: c.typeColor }}>{c.type}</span>
                  <span className="text-xs text-gray-400 font-mono">{c.id}</span>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0" style={{ background: c.statusBg, color: c.statusColor }}>{c.status}</span>
              </div>
              <div className="text-base font-bold text-gray-900 mb-1">{c.title}</div>
              <div className="flex items-center gap-3 text-xs text-gray-400">
                <span><i className="ri-calendar-line mr-1" style={{ fontSize: 11 }} />{c.startDate} ~ {c.endDate}</span>
                <span><i className="ri-user-line mr-1" style={{ fontSize: 11 }} />{c.travelers}</span>
              </div>
            </div>
            {/* Footer */}
            <div className="px-4 py-3 flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-400 mb-0.5">合同金额</div>
                <div className="text-lg font-bold" style={{ color: "#EF4444" }}>{c.amount}</div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={(e) => { e.stopPropagation(); }}
                  className="flex items-center gap-1 px-3 py-1.5 rounded-full text-xs cursor-pointer whitespace-nowrap"
                  style={{ background: "#F5F5F5", color: "#6B7280" }}
                >
                  <i className="ri-download-2-line" style={{ fontSize: 12 }} />下载
                </button>
                <button
                  onClick={() => setSelectedContract(c)}
                  className="flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap text-white active:scale-95 transition-all"
                  style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}
                >
                  查看详情 <i className="ri-arrow-right-s-line" style={{ fontSize: 12 }} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
